module.exports = __webpack_public_path__ + "img/status-solid-unlock.346ca957.svg";